export default __webpack_public_path__ + "/dist/images/2588563.png";